module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Cacahuate_Vaina.dcb0ed75.pdf";